import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DuvidaProvider } from '$providers/duvida';

@Component({
  selector: 'page-duvidas-list',
  templateUrl: 'duvidas-list.html',
})
export class DuvidasListPage {

  keys = '';
  dados: Array<any> = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, private duvidaProvider: DuvidaProvider) {
  }

  ionViewDidLoad() {
    this.duvidaProvider.loadItems().subscribe(
      (dados) => {
        this.dados = [];

        dados.forEach((element) => {
          this.dados.push(
            {
              expanded: false,
              pergunta: element.pergunta,
              resposta: element.resposta
            }
          );
        });
      }
    )
  }

  expandir(duvida) {
    duvida.expanded = !duvida.expanded;
  }
}



// WEBPACK FOOTER //
// ./src/pages/duvidas-list/duvidas-list.ts